export const PIPELINES_STORE_KEY = 'pipeline';
export const PIPELINES_SERVICE_KEY = 'pipeline';
export const PIPELINES_API_URL = '/api/v1/pipeline/';
export const REGIONS_API_URL = '/api/v1/infra/regions';
